import React from "react";
import { Button, ListGroupItem } from "react-bootstrap";
import "./BookSearchResult.css";

export default class BookSearchResult extends React.Component {
  /*	openModal(book) {
		this.setState({ bookDetails: book });
		this.setState({ openBookDetails: true });
		return false;
	}
	closeModal() {
		this.setState({ openBookDetails: false });
		return false;
	}
	addBook = function (data) {
		console.log('Add Book: ', data);
		API.post("books", "user/book", { body: { 'ISBN': data.volumeInfo.industryIdentifiers[0].identifier, 'Info': data, 'Title': data.volumeInfo.title } }).then(
			(response)=>{
				console.log('response: ', response);
				this.setState({addMessage:"Book added succesfully"});
				setTimeout(function() {this.closeModal();}.bind(this),3000);
			}
		);
		
		return;
	}
*/
  render() {
    const book = {
      Info: this.props.src,
      ISBN: this.props.src.volumeInfo.industryIdentifiers[0].identifier
    };

    return (
      <span className="BookSearchResult">
        <ListGroupItem
          className="text-primary"
          key={book.ISBN}
          src={book.ISBN}
          tag="div"
          // eslint-disable-next-line
          onClick={this.props.onClick}
          header={
            book.Title || book.Info
              ? book.Info.volumeInfo
                ? book.Info.volumeInfo.title
                : "Title Not Available"
              : "Title Not Available"
          }
        >
          {book.Info.volumeInfo ? (
            <span className="bookDescription">
              <Button
                className="pull-right floating"
                bsStyle="primary"
                onClick={this.props.onClick}
              >
                {book.Info.owned ? "OWNED" : "ADD"}
              </Button>
              {book.Info.volumeInfo.authors ? (
                book.Info.volumeInfo.authors.map((auth, i) => {
                  return (
                    <span className="bold" key="0">
                      {auth} -{" "}
                    </span>
                  );
                })
              ) : (
                <span key="1">Author unknown</span>
              )}
              <img
                src={
                  book.Info.volumeInfo && book.Info.volumeInfo.imageLinks
                    ? book.Info.volumeInfo.imageLinks.smallThumbnail ||
                      "/img/nocover.png"
                    : "/img/nocover.png"
                }
                alt={book.Title}
                className="img-rounded img-responsive pull-left"
              />
              {book.Info ? (
                book.Info.volumeInfo ? (
                  <span className="subtitle">
                    {book.Info.volumeInfo.subtitle}
                  </span>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              <span className="description">
                {book.Info
                  ? book.Info.volumeInfo.description
                    ? book.Info.volumeInfo.description.length > 800
                      ? book.Info.volumeInfo.description
                          .substr(
                            0,
                            book.Info.volumeInfo.description.indexOf(" ", 800)
                          )
                          .concat("  [...]")
                      : book.Info.volumeInfo.description
                    : "No Description Available"
                  : "No Description Available"}
              </span>
            </span>
          ) : (
            "Book Information Not Available"
          )}
          <span className="bookfooter pull-right"></span>
        </ListGroupItem>
        <div></div>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BookSearchResult.js